import React from 'react';
export function FooterSection() {
  return <footer className="w-full bg-editorial-bg py-12 px-6 md:px-8 border-t border-editorial-divider" data-id="element-56">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-57">
        <p className="text-xs font-sans text-editorial-textMuted opacity-60 mb-4" data-id="element-58">
          © 2026 Temple of Pages. All Rights Reserved.
        </p>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs font-sans text-editorial-textMuted opacity-60" data-id="element-59">
          <a href="#" className="hover:text-editorial-text transition-colors" data-id="element-60">
            Terms
          </a>
          <a href="#" className="hover:text-editorial-text transition-colors" data-id="element-61">
            Privacy
          </a>
          <a href="#" className="hover:text-editorial-text transition-colors" data-id="element-62">
            Refund Policy
          </a>
          <a href="#" className="hover:text-editorial-text transition-colors" data-id="element-63">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}